import { useState, useEffect } from 'react'
import type { Dispatch, SetStateAction } from 'react'
import type { Session } from '@supabase/supabase-js'
import type { Transaction } from '../types'

export function useTours(opts: {
  session: Session | null
  loadingAuth: boolean
  householdLoading: boolean
  householdId: string | null
  sheetOpen: boolean
  editingTx: Transaction | null
}): {
  showTour: boolean
  showSheetTour: boolean
  setShowTour: Dispatch<SetStateAction<boolean>>
  handleTourDone: () => void
  handleSheetTourDone: () => void
} {
  const { session, loadingAuth, householdLoading, householdId, sheetOpen, editingTx } = opts

  const [showTour,      setShowTour]      = useState(false)
  const [showSheetTour, setShowSheetTour] = useState(false)

  useEffect(() => {
    if (!session || loadingAuth || householdLoading || !householdId) return
    if (!localStorage.getItem('bc_tour_done')) {
      const t = setTimeout(() => setShowTour(true), 400)
      return () => clearTimeout(t)
    }
  }, [session, loadingAuth, householdLoading, householdId])

  // Handles both showing the sheet tour on open and dismissing it when sheet closes
  useEffect(() => {
    if (!sheetOpen) {
      if (showSheetTour) {
        localStorage.setItem('bc_sheet_tour_done', '1')
        setShowSheetTour(false)
      }
      return
    }
    if (editingTx || showTour) return
    if (localStorage.getItem('bc_sheet_tour_done')) return
    const t = setTimeout(() => setShowSheetTour(true), 600)
    return () => clearTimeout(t)
  }, [sheetOpen]) // eslint-disable-line react-hooks/exhaustive-deps

  function handleTourDone() {
    localStorage.setItem('bc_tour_done', '1')
    setShowTour(false)
  }

  function handleSheetTourDone() {
    localStorage.setItem('bc_sheet_tour_done', '1')
    setShowSheetTour(false)
  }

  return { showTour, showSheetTour, setShowTour, handleTourDone, handleSheetTourDone }
}
